export class General_Config {
    public static api_url: string = 'https://microshipping.in:3000/';
    public static active_page: string = 'Login';
    public static session_key: string = 'shippinglao_admin_';
    public static image_base: string = 'https://microshipping.in/server/';
}